function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.5,
  cy: 26,
  rx: 16.5,
  ry: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.475 29.124c0-1.962 5.384-3.552 12.025-3.552s12.025 1.59 12.025 3.552"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.009 26l-2.372 5.426C30.009 34 24.997 35.5 17.505 35.5c-7.491 0-12.504-1.5-14.132-4.074L1.001 26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 7c1.393.245 4.245 1.607 4 3-8.485 3.113-14.833 9.11-22 14l-2-1c6.255-5.875 12.293-12.035 20-16z"
}));

var SvgFryingpan = function SvgFryingpan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFryingpan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Frying pan.ee2b8aa6.svg";
export { ForwardRef as ReactComponent };